import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class OnboardingID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
